"use strict";

import React, {useEffect} from 'react';
import FormRequiredLegend from "../../component/FormRequiredLegend";
import objectPath from "object-path";
import {Controller, useForm} from "react-hook-form";
import FormSelect from "../../component/FormSelect";
import dateFormat from "dateformat";
import FormSelectState from "../../component/FormSelectState";
import Icon from "../../component/Icon";
import formInputErrorClassName from "../../formInputErrorClassName";
import scrollTo from "scroll-to";

const AccountEchecksCreateAuthorizeForm = ({
       stepsHeaderOffsetTop=0,
       financialAccountData={},
       financialInstitutionReport={},
       onSubmit=()=>{},
   }) => {
    const {register, handleSubmit, control, reset, getValues, formState: { errors }} = useForm();
    const bankInfo = financialInstitutionReport?.BankInfo || {};
    const bankName = bankInfo?.OrgInfo?.Name || '';
    const decision = financialInstitutionReport?.DecisionInfo?.Decision || [];
    const bankAccountNumber = financialAccountData?.bank_account_number || '';
    const bankAccountNumberMask = bankAccountNumber.substring(bankAccountNumber.length - 4);

    console.log('AccountEchecksCreateAuthorizeForm', bankInfo, decision);

    useEffect(()=>{
        scrollTo( 0, (stepsHeaderOffsetTop || 0), {} );
    }, []);

    useEffect(()=>{
        reset({
            ...getValues(),
            account_name: `${financialAccountData?.f_name || ''} ${financialAccountData?.l_name || ''}`,
            bank_state: financialAccountData?.state,
            bank_city: financialAccountData?.city,
        } );
    }, [financialAccountData, reset, getValues]);

    function formInputClassName(name = '') {
        return formInputErrorClassName(name, errors);
    }

    function handleOnSubmit(formData={}){
        onSubmit({...formData, institution_name: bankName, financialInstitutionReport: {...financialInstitutionReport},});
    }

    return (
        <form id="authorization-create" name="authorization-create" className="is-marginless"
              onSubmit={handleSubmit(handleOnSubmit)}>
            <FormRequiredLegend/>
            <fieldset>
                <legend>Sign Up:</legend>
                <ol className="form__input-list">
                    <li className="form__input-list-item">
                        <label htmlFor="account-type">I authorize Tangible Values, Inc. to initiate electronic debit
                            entries to my:</label>
                        <div className="form__input">
                            {bankName},
                             <span style={{textTransform: 'capitalize',}}> {financialAccountData?.bank_account_type} </span>
                             Account: <span style={{color: '#aaaaaa',}}>#xxxx</span>{bankAccountNumberMask}
                        </div>
                    </li>
                    <li className="form__input-list-item">
                        <label htmlFor="payment-type">for payment of my Tangible Values:</label>
                        <Controller
                            name="for_payment_of"
                            control={control}
                            defaultValue={'INVOICE'}
                            rules={{required: true}}
                            render={({field: { onChange, onBlur, value, },}) =>
                                <FormSelect name="for_payment_of" value={value}
                                            onChange={onChange} onBlur={onBlur} options={[
                                    {value: 'INVOICE', label: 'INVOICE',},
                                ]}/>
                            }
                        />
                    </li>
                    <li className="form__input-list-item">
                        <p><input {...register('ach_acknowledgement', {required: true,})} type="checkbox"
                                  value="yes" className={formInputClassName('ach_acknowledgement')} /> I
                            acknowledge that the origination of ACH transactions to my account must comply
                            with the provisions of U.S. law. This authority will remain in effect until
                            I have revoked my authorization on-line.
                        </p>
                        {!!errors.ach_acknowledgement &&
                        <small className="form__error">
                            You must indicate your acknowledgment
                        </small>
                        }
                    </li>
                    <li className="form__input-list-item">
                        <label>Date:</label>
                        <p>{dateFormat(new Date(), "dddd, mmmm dS, yyyy")}</p>
                    </li>
                    <li className="form__input-list-item">
                        <label htmlFor="account-nick-name" className="required">Your Nickname for Your
                            Account:</label>
                        <input type="text"
                               {...register('account_nick_name', {required: true,})}
                               id="account-nick-name"
                               autoComplete="off"
                               className={formInputClassName('account_nick_name')}
                               placeholder={`Checking ${bankAccountNumberMask}`}
                               maxLength={50} />
                        {!!errors.account_nick_name &&
                        <small className="form__error">
                            An account nickname is required
                        </small>
                        }
                        <p className="footnote minus-top-margin">Note: This will help you remember which
                            bank account this is. <strong>For security reasons</strong> do not add your
                            full bank account number (last 4 is suggested) to your account nick name.</p>
                    </li>
                    <li className="form__input-list-item">
                        <label htmlFor="account-name" className="required">Name On Bank Account:</label>
                        <input type="text"
                               id="account-name"
                               autoComplete="off"
                               maxLength={50}
                               className={formInputClassName('account_name')}
                               {...register('account_name', {required: true,})} />
                        {!!errors.account_name &&
                        <small className="form__error">
                            The name on the account is required
                        </small>
                        }
                    </li>
                    <li className="form__input-list-item">
                        <label htmlFor="bank-city" className="required">Financial Institution City:</label>
                        <input type="text"
                               {...register('bank_city', {required: true,})}
                               id="bank-city"
                               autoComplete="off"
                               maxLength={50}
                               className={formInputClassName('bank_city')} />
                        {!!errors.bank_city &&
                        <small className="form__error">
                            Financial institution city is required
                        </small>
                        }
                    </li>
                    <li className="form__input-list-item">
                        <label htmlFor="bank-state" className="required">Financial Institution State:</label>
                        <Controller
                            name="bank_state"
                            control={control}
                            rules={{required: true}}
                            render={({field: { onChange, onBlur, value, },}) =>
                                <FormSelectState name="bank_state" value={value}
                                                 className={formInputClassName('bank_state')}
                                                 onChange={onChange} onBlur={onBlur}/>
                            }
                        />
                        {!!errors.bank_state &&
                        <small className="form__error">
                            Financial institution state is required
                        </small>
                        }
                    </li>
                </ol>
            </fieldset>
            <fieldset className="submit">
                <button type="submit"
                       name="echeck__account__details"
                       className="btn__primary no-wrap">
                   Next <Icon name="right" className="icon--collapse-right" />
                </button>
            </fieldset>
        </form>
    );
};

export default AccountEchecksCreateAuthorizeForm;
